import { render, staticRenderFns } from "./addSocialAccount.vue?vue&type=template&id=9c1a4bd6&lang=pug"
import script from "./addSocialAccount.vue?vue&type=script&lang=js"
export * from "./addSocialAccount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports